import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import { refreshToken } from '@/api/admin'

// 创建axios实例
const service = axios.create({
  baseURL: '/api', // 接口基础路径
  timeout: 30000 // 请求超时时间
})

// 是否正在刷新token
let isRefreshing = false
// 重试队列
let retryQueue = []

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加token到请求头
    if (store.getters.token) {
      config.headers['accessToken'] = store.getters.token
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 如果返回的状态码不是200，说明接口有异常
    if (res.code !== 200) {
      Message({
        message: res.message || '请求失败',
        type: 'error',
        duration: 5 * 1000
      })
      
      // 401: 未登录或token过期
      if (res.code === 401) {
        // 尝试自动刷新token
        if (store.getters.refreshToken && !isRefreshing) {
          isRefreshing = true
          return store.dispatch('admin/refreshToken').then(() => {
            isRefreshing = false
            // 刷新成功后，重试原请求
            return service(response.config)
          }).catch(() => {
            isRefreshing = false
            // 刷新失败，跳转到登录页
            if (!window.isTokenExpired) {
              window.isTokenExpired = true
              MessageBox.confirm('登录状态已过期，请重新登录', '系统提示', {
                confirmButtonText: '重新登录',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                store.dispatch('admin/logout').then(() => {
                  window.isTokenExpired = false
                  window.location.href = '/'
                })
              }).catch(() => {
                window.isTokenExpired = false
              })
            }
            return Promise.reject(new Error('Token刷新失败'))
          })
        } else {
          // 没有refreshToken或正在刷新，直接跳转登录
          if (!window.isTokenExpired) {
            window.isTokenExpired = true
            MessageBox.confirm('登录状态已过期，请重新登录', '系统提示', {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              store.dispatch('admin/logout').then(() => {
                window.isTokenExpired = false
                window.location.href = '/'
              })
            }).catch(() => {
              window.isTokenExpired = false
            })
          }
        }
      }
      
      return Promise.reject(new Error(res.message || '请求失败'))
    } else {
      return res
    }
  },
  error => {
    console.error('响应错误:', error)
    let message = '网络异常，请稍后重试'
    
    if (error.response) {
      switch (error.response.status) {
        case 400:
          message = '请求参数错误'
          break
        case 401:
          message = '未授权，请重新登录'
          // 避免重复处理
          if (!window.isTokenExpired) {
            window.isTokenExpired = true
            store.dispatch('admin/logout').then(() => {
              window.isTokenExpired = false
              window.location.href = '/'
            })
          }
          break
        case 403:
          message = '拒绝访问'
          break
        case 404:
          message = '请求地址不存在'
          break
        case 500:
          message = '服务器内部错误'
          break
        default:
          message = `连接错误${error.response.status}`
      }
    } else if (error.code === 'ECONNABORTED') {
      message = '网络请求超时'
    } else if (error.message === 'Network Error') {
      message = '网络异常，请检查网络连接'
    }
    
    Message({
      message,
      type: 'error',
      duration: 5 * 1000
    })
    
    return Promise.reject(error)
  }
)

export default service
